/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/product-card';

type Props = {
  variant?: 'list' | 'grid';
  onUndo: () => void;
};

const styles = {
  card: css`
    background-color: var(--cds-color-neutral-background-primary-weak);
    border: 2px solid var(--cds-color-neutral-stroke-primary-weak);
    padding: var(--cds-spacing-300);
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: var(--cds-spacing-200);
  `,
  gridVariant: css`
    /* Below properties copied to match grid variant CDS ProductCard */
    min-height: 200px;
    max-width: 450px;
    min-width: 230px;
  `,
  listVariant: css`
    /* TBC when implementing with ProductCardCollection
       Match properties of list variant CDS ProductCard */
    min-width: 320px;
    max-width: 100%;
  `,
  cardContent: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    text-align: center;
  `,
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  description: css`
    margin-bottom: var(--cds-spacing-50);
  `,
  undoButton: css`
    margin-top: var(--cds-spacing-200);
    align-self: center;
  `,
};

const FeedbackResponseCard = ({ variant = 'grid', onUndo }: Props) => {
  const title = _t('Thank you for your feedback!');
  const description = _t('We value your input and will show you fewer recommendations related to this.');
  const buttonText = _t('Undo');

  return (
    <div css={[styles.card, variant === 'list' ? styles.listVariant : styles.gridVariant]}>
      <div css={styles.cardContent}>
        <div id="feedback-response-text">
          <Typography2 css={styles.title} variant="subtitleMedium" component="div">
            {title}
          </Typography2>
          <Typography2 css={styles.description} component="div">
            {description}
          </Typography2>
        </div>
        <Button
          autoFocus
          aria-describedby="feedback-response-text"
          css={styles.undoButton}
          variant="secondary"
          size="small"
          onClick={onUndo}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default FeedbackResponseCard;
